angular.module('directives.dashboard').directive('wgtInfoYesterdaySaleBrv', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoYesterdaySaleBrv/wgtInfoYesterdaySaleBrv.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                $scope.isLoaded = true;
                                $scope.hasError = false;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                    $scope.anyVisitors = function () {
                        return $scope.widgetData !== undefined ? _.some($scope.widgetData.locations, function(location){ return location.numberOfVisitors > 0 }): false
                    };
                }
            };
        }]
);
